module.exports = __webpack_public_path__ + "static/media/Dipesh.ea578336.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/team/images/Dipesh.jpg
// module id = 1751
// module chunks = 147